import * as d3 from 'd3-selection'
import pointerHandler from '../pointer-handler.js'
import * as interactions from '../interactions.js'

export default function (selection) {
  selection.each(function (data) {
    var container = d3.select(this)
      , items = container.selectAll('.items')
                         .data(function (d) {
                           if (data.hideSelectedOptions) {
                             // We don't want to render the selected options in the control
                             // Commonly used in SB3 principal-chooser where a user can add many items and they are displayed
                             // in a separate component
                             return []
                           }
                           if (data.combo) {
                             // Combo inputs never show these fancy div.input elements,
                             // the selected input is always displayed in the normal input element
                             return []
                           }
                           return [d.options.filter(function (d) {
                                    return d.selected
                                  })]
                         })

    items.exit().remove()

    var item = items.enter()
                    .insert('div', ':first-child') // Force this so it's always before the textarea input
                      .attr('class', 'items')
                      .merge(items)
                      .selectAll('.item')
                      .data(function (d) {
                        return d
                      }, function (d, i) {
                        // Key off value + label + rendered text + index in case we have a situation where an options label changes (common for true/false)
                        // Also includes the index if this select allows changing the tag (i.e. `changeableTags`)
                        return d[data.accessors.value] + ':' + d[data.accessors.label] + ':' + data.render.item.apply(this, arguments) + ':' + (data.changeableTags ? i : '')
                      })
      , enter = item.enter()
                    .insert('div')
                      .attr('class', 'item')
                      .html(data.render.item)
      , _item = enter.merge(item)
      , multiple = enter.filter(function () {
                          return data.multiple
                        })
                        .append('div')
                          .attr('class', 'remove')
                          .on('mousedown.select', pointerHandler(function (e) {
                            let d = d3.select(this.parentNode).datum()
                            d.active = true // Sets active property on the data bound to the parent node,
                                            // which is the actual option.
                            interactions.remove(data, d, _item.data())
                            e.stopPropagation()

                            process.nextTick((function () {
                              container.select('textarea:last-child').node().focus()
                            }).bind(this))
                          }))

    multiple.append('svg')
              .attr('class', 'icon-delete')
              .attr('viewbox', '0 0 7 7')
              .append('path')
                .attr('d', 'M.666.067C.276.09-.05.56.072.934c.1.2.306.322.45.492l2.09 2.08c-.8.8-1.607 1.595-2.403 2.398-.34.327-.12.846.28.987.29.167.573-.03.744-.26L3.49 4.39c.804.797 1.6 1.6 2.408 2.393.32.325.804.124.99-.23.172-.324-.08-.642-.316-.85l-2.2-2.19L6.724 1.17c.38-.26.22-.816-.134-1.013C6.3-.04 5.94.11 5.76.37L3.494 2.627c-.803-.797-1.6-1.6-2.406-2.393C.97.134.822.067.668.067z')

    multiple.filter(function () {
              return data.render.itemRemove
            })
            .html(data.render.itemRemove)

    item.exit()
        .remove()

    _item.attr('class', function (d) {
           return 'item ' + (d.clazz || '')
         })
         .classed('active', function (d) {
           return d.active
         })
         .on('mousedown.select', pointerHandler(function (e) {
           if (data.multiple) {
             // Prevent mousedown from continuing, which would end up making the menu open/close when
             // they click a tag
             e.stopPropagation()
           }
         }))
         .on('click', pointerHandler(function (e, d) {
           if (data.multiple) {
             interactions.activateTag(data, d, _item.data())
             e.stopPropagation()
             e.preventDefault() // Prevent `label` click events to try and focus the select if this rich select is embedded in a `label`
             container.select('textarea:last-child').node().focus()
           }
         }))

    if (data.changeableTags) {
      // Make sure the DOM order matches the `options` order in case they modified a tag
      _item.order()
    }
  })
}
